import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { DeviceSyncStatus } from '@rocksoft/apple-sync-sdk';

@Component({
  selector: 'era-device-mdm-sync-retry-ui',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-mdm-sync-retry.component.html',
})
export class DeviceMdmSyncRetryComponent {
  public readonly deviceSyncStatus = input.required<DeviceSyncStatus>();
  public readonly retry = output<DeviceSyncStatus>();

  public onRetry() {
    this.retry.emit(this.deviceSyncStatus());
  }
}
